import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

import DraftDeleteMask from './Draft/DraftDeleteMask.jsx';
import DraftOptions from './Draft/DraftOptions.jsx';
import DraftNotebook from './Draft/DraftNotebook.jsx';
import DraftSettingsTrigger from './Draft/DraftSettingsTrigger.jsx';


export default class Draft extends Component {
    static propTypes = {
        draft: PropTypes.object.isRequired,
        onEdit: PropTypes.func.isRequired,
        onRemoveCategory: PropTypes.func.isRequired,
        onRemoveAll: PropTypes.func.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            visibleOptions: false,
            activeDeleteMask: false
        };
    }

    componentWillUnmount() {
    }

    handleSettingsTrigger() {
        this.setState({ visibleOptions: !this.state.visibleOptions });
    }
    openDeleteMask() {
        this.setState({ activeDeleteMask: true })
    }
    closeDeleteMask() {
        this.setState({ activeDeleteMask: false })
    }

    render() {
        const optionClassName = classNames({
            'box-drafts__aside': true,
            '-opt-opened': this.state.visibleOptions
        });
        const { draft } = this.props;
        return (
        <div className="box-drafts">
            <h2>{draft.title}</h2>
            <p>{draft.description}</p>
            <a className="btn" href={draft.link}>{Translator.trans('drafts.open_category', [], 'app')}</a>
            <div className={optionClassName}>
                <DraftOptions onDeleteClick={::this.openDeleteMask} onEditClick={this.props.onEdit}
                              onMoveClick={()=>{console.log('move')}}/>
                <DraftNotebook number={draft.count} name={draft.name_variant}/>
                <DraftSettingsTrigger onTrigger={::this.handleSettingsTrigger}/>
            </div>
            <DraftDeleteMask active={this.state.activeDeleteMask} id={draft.id} onRemoveAll={this.props.onRemoveAll}
                             onRemoveCategory={this.props.onRemoveCategory}
                             onClose={::this.closeDeleteMask}/>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Draft.jsx